import { getFirstAccessibleRoute } from "@/constants/Auth";
import Auth from "@/constants/Auth";
import LocalStorage from "@/utilities/LocalStorage";
import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_auth/")({
  beforeLoad: ({ context }) => {
    // Şirket seçilmemişse proje seçim ekranına yönlendir
    const selectedCompany = LocalStorage.selectedCompany()
    if (!selectedCompany) {
      throw redirect({
        to: Auth.projectSelectPath,
      })
    }

    // Son ziyaret edilen sayfayı kontrol et
    const lastVisitedPage = localStorage.getItem("lastVisitedPage")

    // Eğer son ziyaret edilen sayfa varsa oraya yönlendir
    if (lastVisitedPage && lastVisitedPage !== "/" && lastVisitedPage !== "/login" && lastVisitedPage !== Auth.projectSelectPath) {
      throw redirect({
        to: lastVisitedPage,
      })
    } else {
      // Yoksa varsayılan olarak ilk erişilebilir route'a yönlendir
      const permissions = context.auth.user?.permissions || [];
      const redirectPath = getFirstAccessibleRoute(permissions);
      throw redirect({
        to: redirectPath,
      })
    }
  },
})
